import { WIKO_ERROR__CODECS__INVALID_NUMBER_OF_ITEMS, WikoError } from '@wiko/errors';

/** Checks the number of items in an array-like structure is expected. */
export function assertValidNumberOfItemsForCodec(
    codecDescription: string,
    expected: bigint | number,
    actual: bigint | number,
) {
    if (expected !== actual) {
        throw new WikoError(WIKO_ERROR__CODECS__INVALID_NUMBER_OF_ITEMS, {
            actual,
            codecDescription,
            expected,
        });
    }
}
